(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    /*
  LSC - 2026-10-12 product audit #20: variant-change handling for the buy area.

  Before: every `change` event anywhere on the document (any form field, any
  section) triggered a fetch of the WHOLE main-product section, and the
  container swap ran on every variant change even though the server output only
  differs when custom.consult_required differs between variants.

  Now:
  - Trigger: the theme's own `variantChange` pubsub event, filtered to this
    section. The theme publishes it once per variant change, AFTER it has
    updated price, inputs and the submit buttons - so the variant id is final
    (the old `change` + requestAnimationFrame fallback could read the previous
    id because the theme updates the hidden input only after its own fetch).
    If theme.pubsub is missing, a fallback listens for `change` only inside
    this section's variant picker (<product-info>), not the whole document.
  - Fetch: only when the consult flag (from #LscBuyVariantMap-<section>)
    differs between the old and new variant. Then #buy-button-container,
    #consult-required-container and the sticky-bar button wrapper
    ([data-lsc-sticky-buy], audit #10) are swapped from the fresh render.
  - No fetch: the theme already updated price/availability; the script only
    re-applies the "Pre-Order" label (theme JS resets it to "Add to cart") and
    keeps the buttons' aria-labels in step with the selected variant.
*/
document.addEventListener('DOMContentLoaded', () => {
  const BUY_ID = 'buy-button-container';
  const CONSULT_ID = 'consult-required-container';

  const initialBuy = document.getElementById(BUY_ID);
  if (!initialBuy) return;

  const sectionId = initialBuy.dataset.sectionId;

  // LSC - per-variant map rendered by Liquid next to the container.
  const mapEl = document.getElementById(`LscBuyVariantMap-${sectionId}`);
  let data = { variants: {}, labels: {} };
  try {
    if (mapEl) data = JSON.parse(mapEl.textContent);
  } catch (error) {
    console.error('LSC buy-buttons: could not read variant map', error);
  }
  const variantsInfo = data.variants || {};
  const labels = data.labels || {};

  // LSC - consult flag for a variant id; unknown ids count as "not required".
  const consultOf = (id) => Boolean(variantsInfo[String(id)] && variantsInfo[String(id)].c);
  const preOrderOf = (id) => Boolean(variantsInfo[String(id)] && variantsInfo[String(id)].p);

  let currentVariantId = String(
    (mapEl && mapEl.dataset.initialVariant) ||
    document.querySelector(`#${BUY_ID} form[is="product-form"] input[name="id"]`)?.value ||
    new URLSearchParams(window.location.search).get('variant') ||
    ''
  );

  let activeRequest = null;

  // LSC - consult status of what is currently RENDERED in the buy area (may
  // lag currentVariantId while a re-render is in flight).
  let renderedConsult = consultOf(currentVariantId);

  // LSC - all submit buttons that belong to this product's form: the main one
  // inside #buy-button-container and the sticky bar one (form="<id>").
  function submitButtons() {
    const form = document.querySelector(`#${BUY_ID} form[is="product-form"]`);
    // getAttribute, not form.id: the form contains <input name="id">, which
    // shadows the form's .id property (it returns that input element).
    const formId = form && form.getAttribute('id');
    if (!formId) return [];
    return Array.from(document.querySelectorAll(`button[type="submit"][name="add"][form="${formId}"]`));
  }

  // LSC - re-apply label/aria after the theme's own update (no fetch).
  function syncLabels(variant) {
    const isPreOrder = preOrderOf(variant.id);
    submitButtons().forEach((button) => {
      if (isPreOrder) {
        // Same text the server renders for the Pre-Order tag case.
        const textNode = button.querySelector('.btn-text>span') || button.querySelector('.btn-text');
        if (textNode) textNode.textContent = labels.preOrderTag || 'Pre-Order';
        button.setAttribute('aria-label', labels.preOrderTag || 'Pre-Order');
      } else if (variant.available === false) {
        if (labels.soldOut) button.setAttribute('aria-label', labels.soldOut);
      } else {
        const aria = labels.templatePreOrder ? labels.preOrderAria : labels.addAria;
        if (aria) button.setAttribute('aria-label', aria);
      }
    });
  }

  async function rerenderContainers(variantId) {
    if (!variantId) return;

    const requestId = String(variantId);
    activeRequest = requestId;

    try {
      const url = `${window.location.pathname}?section_id=${sectionId}&variant=${variantId}`;

      const response = await fetch(url, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch section: ${response.status}`);
      }

      const html = await response.text();

      // Prevent race conditions
      if (activeRequest !== requestId) return;

      const parsed = new DOMParser().parseFromString(html, 'text/html');

      // --- BUY BUTTON ---
      const currentBuy = document.getElementById(BUY_ID);
      const newBuy = parsed.getElementById(BUY_ID);

      if (currentBuy && newBuy) {
        currentBuy.replaceWith(newBuy);
      }

      // --- CONSULT REQUIRED ---
      const currentConsult = document.getElementById(CONSULT_ID);
      const newConsult = parsed.getElementById(CONSULT_ID);

      if (currentConsult && newConsult) {
        currentConsult.replaceWith(newConsult);
      }

      // --- STICKY BAR BUTTON (LSC - audit #10) ---
      // Swap the sticky bar's button wrapper so a guest on a consult-required
      // variant sees Log In there too (never a submit button for a form that
      // is not rendered). The theme's <product-sticky-form> caches its submit
      // button in _submitButton, so that cache is cleared after the swap.
      const stickySelector = `[data-lsc-sticky-buy="${sectionId}"]`;
      const currentSticky = document.querySelector(stickySelector);
      const newSticky = parsed.querySelector(stickySelector);

      if (currentSticky && newSticky) {
        currentSticky.replaceWith(newSticky);
        const stickyForm = newSticky.closest('product-sticky-form');
        if (stickyForm) stickyForm._submitButton = null;
      }

      // LSC - the DOM now reflects this variant's consult status.
      renderedConsult = consultOf(requestId);

    } catch (error) {
      console.error('Error updating containers:', error);
    } finally {
      // LSC - clear the in-flight marker only if no newer request replaced it.
      if (activeRequest === requestId) activeRequest = null;
    }
  }

  // LSC - core handler: fetch only when the consult flag changes.
  function handleVariantChange(variant) {
    if (!variant || !variant.id) return;
    const normalized = String(variant.id);
    if (normalized === currentVariantId) return;

    currentVariantId = normalized;

    if (activeRequest || consultOf(normalized) !== renderedConsult) {
      // Server output differs from what is on screen (Log In vs Add to cart,
      // consult notice, sticky button) - or a re-render is still in flight and
      // must be re-targeted at this variant - so re-render for the new variant.
      rerenderContainers(normalized);
    } else {
      // Same consult status as rendered: nothing server-side changes; the
      // theme already updated price/availability - just keep labels right.
      syncLabels(variant);
    }
  }

  if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
    // Primary: the theme's own variant-change event, scoped to this section.
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
      const payload = event && event.data;
      if (!payload || String(payload.sectionId) !== String(sectionId)) return;
      handleVariantChange(payload.variant);
    });
  } else {
    // Fallback (theme pubsub unavailable): only changes made inside this
    // section's variant picker, never every change on the document.
    const productInfo = initialBuy.closest('product-info');
    if (!productInfo) return;
    productInfo.addEventListener('change', (event) => {
      if (!event.target.closest('variant-picker')) return;
      // Give the theme time to update the hidden id input.
      setTimeout(() => {
        const id = document.querySelector(`#${BUY_ID} form[is="product-form"] input[name="id"]`)?.value ||
          new URLSearchParams(window.location.search).get('variant');
        if (id) handleVariantChange({ id: id, available: true });
      }, 600);
    });
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lsc-video"] && !Shopify.designMode) return;
  try {
    // One playlist request per video URL, shared by every player that uses it.
  var playlistRequests = {};

  // Variant entry in a Shopify master playlist, e.g.
  //   #EXT-X-STREAM-INF:...,RESOLUTION=1280x720,...
  //   {id}.HD-720p.2.1Mbps.hls.95567414_.m3u8
  // Captures: width, height, id, HD|SD, lines, bitrate, version.
  var VARIANT = /RESOLUTION=(\d+)x(\d+)[^\n]*\n(\S+?)\.(HD|SD)-(\d+)p\.([\d.]+)Mbps\.hls\.(\d+)_\.m3u8/g;

  // Largest rendition whose short side fits the cap, as an MP4 file name.
  function pickRendition(playlist, maxShortSide) {
    var best = null;
    var match;
    VARIANT.lastIndex = 0;
    while ((match = VARIANT.exec(playlist))) {
      // LSC - 2026-10-12 home audit: cap by HEIGHT (match[2]), not min(width, height),
      // so vertical renditions (e.g. 606x1080) are judged as 1080p, like the Liquid
      // pick above and assets/lsc-hero-slideshow.js. Name kept to keep the diff small.
      var shortSide = Number(match[2]);
      if (shortSide <= maxShortSide && (!best || shortSide > best.shortSide)) {
        best = {
          shortSide: shortSide,
          file: match[3] + '.' + match[4] + '-' + match[5] + 'p-' + match[6] + 'Mbps-' + match[7] + '.mp4'
        };
      }
    }
    return best;
  }

  function resolvePlayer(player) {
    // Once per player, and never for a player hidden at this breakpoint (its twin is shown).
    if (player.hasAttribute('data-lsc-resolved')) return;
    if (window.getComputedStyle(player).display === 'none') return;
    player.setAttribute('data-lsc-resolved', '');

    var playlistUrl = player.getAttribute('data-lsc-hls');
    var maxShortSide = Number(player.getAttribute('data-lsc-max')) || 720;
    if (!playlistRequests[playlistUrl]) {
      playlistRequests[playlistUrl] = fetch(playlistUrl).then(function (response) {
        if (!response.ok) throw new Error('playlist ' + response.status);
        return response.text();
      });
    }

    playlistRequests[playlistUrl].then(function (playlist) {
      var rendition = pickRendition(playlist, maxShortSide);
      // The theme replaces <template> with the built <video>; if it already did, leave it alone.
      var template = player.querySelector('template');
      var source = template && template.content.querySelector('video source');
      if (!rendition || !source) return;
      // MP4 renditions live next to the playlist on the CDN.
      source.setAttribute('src', playlistUrl.slice(0, playlistUrl.lastIndexOf('/') + 1) + rendition.file);
      player.setAttribute('data-lsc-rendition', rendition.shortSide + 'p');
    }).catch(function () {
      // Keep the original (largest) MP4: same behaviour as before this script existed.
    });
  }

  function resolveAll(root) {
    var players = (root || document).querySelectorAll('video-media[data-lsc-hls]');
    for (var i = 0; i < players.length; i++) resolvePlayer(players[i]);
  }

  resolveAll();
  // A hidden twin becomes the visible player when the viewport crosses the theme's 768px split.
  if (window.matchMedia) {
    var breakpoint = window.matchMedia('(min-width: 768px)');
    var onChange = function () { resolveAll(); };
    if (breakpoint.addEventListener) breakpoint.addEventListener('change', onChange);
    else if (breakpoint.addListener) breakpoint.addListener(onChange);
  }
  // Theme editor: sections are re-rendered in place.
  document.addEventListener('shopify:section:load', function (event) { resolveAll(event.target); });

  // ---------------------------------------------------------------------------
  // LSC - 2026-10-12 product audit #33: keep the play/pause button's accessible
  // name and pressed state in step with the video.
  //
  // The theme's <video-media> (assets/theme.js, not editable) builds the
  // <video> from its <template> only when the player scrolls into view or is
  // clicked, and plays/pauses it itself; it never touches the button's label.
  // So this listens at the DOCUMENT level instead of binding to each player:
  //   - native `play` / `pause` / `ended` events of <video> (they do not
  //     bubble, hence the capture-phase listeners), and
  //   - the theme's own bubbling `video:play` / `video:pause` events, which
  //     it fires when it sets/removes [playing] (also covers YouTube/Vimeo
  //     players, which have no <video> element).
  // Delegation means every player is covered, including ones built later or
  // added by a section re-render in the theme editor, with no re-binding.
  // Only buttons rendered by this snippet ([data-lsc-play-toggle]) are touched.
  // ---------------------------------------------------------------------------
  function syncPlayToggle(player, playing) {
    if (!player) return;
    var toggle = player.querySelector(':scope > [data-lsc-play-toggle]');
    if (!toggle) return;
    var label = playing ? toggle.getAttribute('data-lsc-label-pause') : toggle.getAttribute('data-lsc-label-play');
    if (label) toggle.setAttribute('aria-label', label);
    toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
  }

  // Native <video> events: read the element's real state (paused is false
  // during playback, true after pause/ended).
  function onMediaEvent(event) {
    var target = event.target;
    if (!target || target.tagName !== 'VIDEO' || !target.closest) return;
    syncPlayToggle(target.closest('video-media'), !target.paused && !target.ended);
  }
  document.addEventListener('play', onMediaEvent, true);
  document.addEventListener('pause', onMediaEvent, true);
  document.addEventListener('ended', onMediaEvent, true);

  // Theme events from <video-media> itself (target is the player element).
  document.addEventListener('video:play', function (event) {
    if (event.target && event.target.tagName === 'VIDEO-MEDIA') syncPlayToggle(event.target, true);
  });
  document.addEventListener('video:pause', function (event) {
    if (event.target && event.target.tagName === 'VIDEO-MEDIA') syncPlayToggle(event.target, false);
  });

  // Initial pass, in case a player was already playing before this deferred
  // bundle ran (the theme's [playing] attribute is the source of truth).
  function syncAllPlayToggles(root) {
    var toggles = (root || document).querySelectorAll('video-media > [data-lsc-play-toggle]');
    for (var i = 0; i < toggles.length; i++) {
      var player = toggles[i].parentElement;
      syncPlayToggle(player, player.hasAttribute('playing'));
    }
  }
  syncAllPlayToggles();
  document.addEventListener('shopify:section:load', function (event) { syncAllPlayToggles(event.target); });

  // ---------------------------------------------------------------------------
  // LSC - 2026-10-19, change 5 (with change 4a folded in): a tap on the play
  // button always starts the video, including for visitors with reduced
  // motion turned on. See the file header for the full reasoning.
  //
  // Capture phase on document, so this runs BEFORE the theme's own click
  // handler on the play button (the theme stops propagation, so a bubbling
  // listener would never fire).
  //
  // Order inside the tap:
  //   1. Build the <video> if the theme hasn't yet: clone the <template>'s
  //      first element (exactly what the theme does) and put it in the
  //      template's place. Before inserting, give it the poster <img>'s
  //      currentSrc as `poster` (change 4a: same file already on screen, so a
  //      cache hit; skips the 1x1 data-URI placeholder and never overwrites an
  //      existing poster).
  //   2. If the video is already playing, stop here and let the theme pause it.
  //   3. Re-assert muted / playsInline as properties, then call play()
  //      synchronously, so iOS sees it as part of the tap and allows it.
  // A refused play() is swallowed here; the theme's own play() call that
  // follows handles the fallback (poster + native controls).
  // Only native videos from this snippet; YouTube/Vimeo ([host]) are left to
  // the theme, which drives them through their own player APIs.
  // ---------------------------------------------------------------------------
  function posterFromImage(player, video) {
    if (video.hasAttribute('poster')) return;
    var image = player.querySelector(':scope > .lsc-vto__poster > img, :scope > img');
    var posterSrc = image && image.currentSrc;
    if (posterSrc && posterSrc.indexOf('data:') !== 0) video.setAttribute('poster', posterSrc);
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target && event.target.closest && event.target.closest('[data-lsc-play-toggle]');
    if (!toggle) return;
    var player = toggle.parentElement;
    if (!player || !player.classList.contains('lsc-video-media') || player.hasAttribute('host')) return;

    // 1. Build the video in place of the template (first tap only).
    var video = player.querySelector(':scope > video');
    if (!video) {
      var template = player.querySelector(':scope > template');
      var templateVideo = template && template.content.firstElementChild;
      if (!templateVideo || templateVideo.tagName !== 'VIDEO') return;
      video = templateVideo.cloneNode(true);
      posterFromImage(player, video);
      template.replaceWith(video);
    }

    // 2. Already playing: the theme's handler pauses it.
    if (!video.paused || player.hasAttribute('playing')) return;

    // 3. Start playback inside the tap.
    video.muted = video.hasAttribute('muted');
    video.playsInline = true;
    try {
      var attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(function () {});
    } catch (error) {
      // Very old browsers without a play() promise: nothing to do, the theme follows up.
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
